  $(document).ready(function(){
  
  $(".cart-pitem li").each(function(){
   var h1 = $(this).attr("data-hndle");
   $(".set-modal .cart-product[data-handle='"+h1+"']").remove(); 
  });
  
  var sets = $(".set-modal .cart-product").length;
  if(sets != 0)
  {
    $(".set-modal .cart-product:nth-child(2)").show();
    $(".set-modal").show();
  }
    
    $(".set-modal .custom-options .custom-swatch:nth-child(2)").addClass("active");
    $(".set-modal .custom-swatch").on("click",function(){
     $(this).addClass("active").siblings().removeClass("active");
      var id = $(this).attr("data-id");
      var price = $(this).parents(".cart-product").find(".vriant-price div[data-id='"+id+"']").html();
      $(this).parents(".cart-product").find(".item-price").html(price);
    });  
    
    $(".set-remove").on("click",function(){
     var id = $(this).attr("data-set-id");
     change(id); 
    });
    
    $(".set-add").on("click",function(){
      var id = $(this).parents(".cart-product").find(".custom-swatch.active").attr("data-id");
      var set_id = $(this).attr("data-set-id");
      var quantity = $(".cart-pitem li[data-id='"+set_id+"']").attr("data-quantity");
      var identity = Math.floor((Math.random() * 1000) + 1);
      var bundle = $(".cart-item-1[data-id='"+set_id+"']").find(".cart-table-title").text();
      if(bundle.indexOf("Cart Upsell & Cross Sell") != -1)
      {
        var bndle = 'Cart Upsell & Cross Sell';
      }
      if(bundle.indexOf("Related products") != -1)
      {
        var bndle = 'Related products';
      }
      
      var addthis = {
        "id": set_id,
        "quantity": quantity,
        "properties": {
          "identity": identity,
          "_bundle": bndle
        }
      }
      
      var addthis1 = {
        "id": id,
        "quantity": quantity,
        "properties": {
          "identity": identity
        }
      }
      
      var selector = $(this).parents(".cart-product");
      $(this).addClass("disable_btn");
      
      $.ajax({
          type:"POST",
          url:"/cart/change.js",
          data:"quantity=0&id="+set_id,
          success:function(){
			$.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: addthis,
              success:function(){
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: addthis1,
                  success:function(){
                    if(selector.next(".cart-product").length > 0)
                    {
                      $(".set-add").removeClass("disable_btn");
                      selector.fadeOut("slow");
                      setTimeout(function(){
                       selector.next(".cart-product").fadeIn("slow");
                      }, 200);  
                    }
                    else
                    {
					 location.reload();
                    }
                  }
                });
              }
            });
          }
         })
      
    });
    
      
      function change(id){
      	$.ajax({
          type:"POST",
          url:"/cart/change.js",
          data:"quantity=0&id="+id,
          async:false,
          success:function(){
			location.reload();
          }
         })
      }  
  });
